import { useState, useCallback } from "react";
import { AlertAnalysisService } from "../../../application/services/aiServices/alertAnalysisService";

const alertAnalysisService = new AlertAnalysisService();

export const useAlertAnalysis = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [alertAnalysis, setAlertAnalysis] = useState(null);
  const [allAlertAnalyses, setAllAlertAnalyses] = useState([]);

  const getAlertAnalysis = useCallback(async (vmId) => {
    setLoading(true);
    setError(null);
    try {
      const result = await alertAnalysisService.getAlertAnalysis(vmId);
      if (result.success) {
        setAlertAnalysis(result.data);
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  }, []);

  const getAllAlertAnalyses = useCallback(async (vmId) => {
    setLoading(true);
    setError(null);
    try {
      const result = await alertAnalysisService.getAlertAnalysis(vmId);
      if (result.success) {
        const dataArray = Array.isArray(result.data) ? result.data : [result.data];
        setAllAlertAnalyses(dataArray);
        return { success: true, data: dataArray };
      } else {
        setError(result.message);
        return { success: false, message: result.message, data: [] };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message, data: [] };
    } finally {
      setLoading(false);
    }
  }, []);

  const analyzeAlertsForVm = useCallback(async (vmId) => {
    setLoading(true);
    setError(null);
    try {
      const result = await alertAnalysisService.analyzeAlertsForVm(vmId);
      if (result.success) {
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  }, []);

  const analyzeAllVmsAlerts = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await alertAnalysisService.analyzeAllVmsAlerts();
      if (result.success) {
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    getAlertAnalysis,
    getAllAlertAnalyses,
    analyzeAlertsForVm,
    analyzeAllVmsAlerts,
    alertAnalysis,
    allAlertAnalyses,
    loading,
    error,
  };
};